import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { CookieService } from 'ngx-cookie-service';
import { SettingsService } from 'src/app/views/settings/settings.service';
import { FullLoaderService } from 'src/app/shared/services/full-loader.service';
import { NgxFileDropEntry } from 'ngx-file-drop';
import { v4 as uuidv4 } from "uuid";
import { AwsSdkService } from 'src/app/shared/services/aws-sdk.service';
import { WebApiService } from 'src/app/shared/services/web-api.service';

@Component({
  selector: 'app-service-purchase-order-payment-terms',
  templateUrl: './service-purchase-order-payment-terms.component.html',
  styleUrls: ['./service-purchase-order-payment-terms.component.css']
})
export class ServicePurchaseOrderPaymentTermsComponent implements OnInit {

  isForm1Expand: boolean = true;
  isForm2Expand: boolean = true;
  isForm3Expand: boolean = true;

  serviceRfqId!: number;
  quoteId!: number;
  servicePurchaseOrderId!: number;
  currentTab: string = 'payment-terms';

  paymentFormGroup!: UntypedFormGroup;

  uploadedAdditionalAttachmentsArray: any[] = [];
  acceptedAttachmentExtenstion: any = ['.pdf', '.jpg', '.jpeg', '.png'];
  maxFileSize: number = 10 * 1024 * 1024; // 10MB

  previewSection: boolean = false;
  previewDoc: any[] = [];
  currentIndex = 0;

  portAgentData: any[] = [];
  billingAddressData: any[] = [];
  billingAddress!: string;

  showConfirmationDialogue: boolean = false;
  showCloseDialogue: boolean = false;

  tabs: any[] = [
    {
      index: 0,
      label: 'LINE ITEMS',
      icon: "directions_boat",
      route: 'line-items',
    },
    {
      index: 1,
      label: 'HEADER DETAILS',
      icon: "looks",
      route: 'header',
    },
    {
      index: 2,
      label: 'PAYMENT TERMS',
      icon: "location_searching",
      route: 'payment-terms',
    },
    {
      index: 3,
      label: 'PREVIEW',
      icon: "location_searching",
      route: 'preview',
    }
  ];

  constructor(
    private snack: MatSnackBar,
    private _formBuilder: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    private cookieService: CookieService,
    private router: Router,
    private SettingsService: SettingsService,
    private fullLoaderService: FullLoaderService,
    private activatedRoute: ActivatedRoute,
    private awsSdkService: AwsSdkService,
    private webApiService: WebApiService
  ) {}

  async ngOnInit() {
    this.fullLoaderService.showLoader();

    this.paymentFormGroup = this._formBuilder.group({
      // Buyer Payment Terms
      billingAddress: [''],
      billingAddressType: [''],
      applicableTaxProfile: [''],
      buyersPaymentTerms: [''],
      buyerTermsAndConditions: [''],

      // Port Agent Details (portAgentId is mandatory)
      portAgentId: ['', Validators.required],
      portAgencyName: [''],
      portAgentName: [''],
      portAgentPhoneNumber: [''],
      portAgentContact: [''],
      portAgentPhoneFax: [''],
      portAgentEmail: [''],
      portAgentAddress: [''],

      // Terms and Conditions (file upload + text)
      termsAndConditions: [''],
      attachments: [null]
    });

    const params = this.activatedRoute.snapshot.queryParams;

    if (params['serviceRfqId'] && params['quoteId'] && params['servicePurchaseOrderId']) {
      this.serviceRfqId = params['serviceRfqId'];
      this.quoteId = params['quoteId'];
      this.servicePurchaseOrderId = params['servicePurchaseOrderId'];

      // Fetch payment terms data
      const fetchParams = {
        purchaseOrderId: this.servicePurchaseOrderId,
        section: 'paymentTerms'
      };
      const result = await this.SettingsService.fetchServicePurchaseOrder(fetchParams);
      console.log({ result });

      if (result && result.length > 0) {
        const response = result[0];

        this.billingAddress = response.billingAddress;
        this.paymentFormGroup.patchValue({
          billingAddress: response.billingAddress,
          billingAddressType: response.invoiceAddressType,
          applicableTaxProfile: response.applicableTaxProfile,
          buyersPaymentTerms: response.buyersPaymentTerms,
          buyerTermsAndConditions: response.termsAndConditions,
          portAgentId: response.portAgentId,
          portAgencyName: response.portAgencyName,
          portAgentName: response.portAgentName,
          portAgentPhoneNumber: response.portAgentPhoneNumber,
          portAgentContact: response.portAgentContact,
          portAgentPhoneFax: response.portAgentPhoneFax,
          portAgentEmail: response.emailId,
          portAgentAddress: response.address,
          termsAndConditions: response.termsAndConditions,
        });

        this.uploadedAdditionalAttachmentsArray = response.paymentTermsAttachments || [];
      }

      // Fetch dropdown data
      this.fetchPortAgentByUserId();
      this.fetchBillingAddressByUserId();
    }

    this.fullLoaderService.hideLoader();
  }

  async fetchPortAgentByUserId() {
    const result = await this.SettingsService.fetchPortAgentByUserId(Number(this.cookieService.get('userId')));
    this.portAgentData = result.rows;
    console.log("portAgentData", this.portAgentData);
  }

  async fetchBillingAddressByUserId() {
    const address = await this.SettingsService.fetchBranchAddressFilterValues(Number(this.cookieService.get('userId')), 2);
    this.billingAddressData = address.data;
    console.log("billingAddressData", this.billingAddressData);
  }

  onPortAgentSelected(value: any) {
    const selectedPortAgent = this.portAgentData.find(portAgent => portAgent.id === value);
    console.log("selectedPortAgent", selectedPortAgent);

    this.paymentFormGroup.patchValue({
      portAgencyName: selectedPortAgent.portAgencyName,
      portAgentName: selectedPortAgent.portAgentName,
      portAgentPhoneNumber: selectedPortAgent.phone,
      portAgentContact: selectedPortAgent.contact,
      portAgentPhoneFax: selectedPortAgent.fax,
      portAgentEmail: selectedPortAgent.emailID,
      portAgentAddress: selectedPortAgent.street,
    });
  }

  toggleVisibility(section: string) {
    if (section == 'form1') {
      this.isForm1Expand = !this.isForm1Expand;
    } else if (section == 'form2') {
      this.isForm2Expand = !this.isForm2Expand;
    } else if (section == 'form3') {
      this.isForm3Expand = !this.isForm3Expand;
    }
  }

  // File upload handling
  async onAdditionalFileSelected(files: NgxFileDropEntry[]) {
    try {
      this.fullLoaderService.showLoader();
      this.uploadedAdditionalAttachmentsArray =
        this.paymentFormGroup.get('attachments')?.value || [];

      if (this.uploadedAdditionalAttachmentsArray.length > 5) {
        throw new Error('Maximum 5 files allowed!');
      }

      const fileEntries = files
        .filter((entry) => entry.fileEntry.isFile)
        .map((ele) => ele.fileEntry as FileSystemFileEntry);

      if (fileEntries.length === 0) {
        throw new Error('Please upload valid files!');
      }
      if (fileEntries.length > 5) {
        throw new Error('Maximum 5 files allowed!');
      }

      await new Promise((res, rej) => {
        fileEntries.map((fileEntry) => {
          fileEntry.file(async (file) => {
            let fileExt = file.name.split('.').pop();
            if (!this.acceptedAttachmentExtenstion.includes(`.${fileExt}`)) {
              return;
            }

            if (file.size > this.maxFileSize) {
              throw new Error('File size must be less than 10MB!');
            }

            let uploadedAttachment: any = {
              dataUrl: '',
              name: file.name,
              file: file
            };

            await new Promise((res, rej) => {
              const reader = new FileReader();
              reader.onload = (e: any) => {
                uploadedAttachment.dataUrl = e.target.result;
                res(true);
              };
              reader.readAsDataURL(file);
            });

            this.uploadedAdditionalAttachmentsArray.push(uploadedAttachment);
            res(file);
          });
        });
      });

      this.paymentFormGroup.get('attachments')?.setValue(this.uploadedAdditionalAttachmentsArray);
      this.fullLoaderService.hideLoader();

    } catch (error: any) {
      this.snack.open(error, 'OK', {
        duration: 1000,
      });
    }
  }

  // Carousel preview
  async togglePreview(value: boolean, section: string, index?: number) {
    this.currentIndex = 0;

    if (value) {
      if (section == 'generalAttachment') {
        if (value) {
          this.previewDoc = this.uploadedAdditionalAttachmentsArray;
          console.log("previewDoc", this.previewDoc);
        } else {
          this.previewDoc = [];
        }
      }
    } else {
      this.previewDoc = [];
    }

    this.previewSection = value;
  }

  getHeaderAttachmentCount(): any {
    return this.uploadedAdditionalAttachmentsArray.length;
  }

  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.previewDoc.length;
  }

  prevSlide() {
    this.currentIndex = (this.currentIndex - 1 + this.previewDoc.length) % this.previewDoc.length;
  }

  isPdf(urlOrDataUrl: string): boolean {
    if (urlOrDataUrl?.toLowerCase().startsWith('data:application/pdf')) {
      return true;
    }
    return urlOrDataUrl?.toLowerCase().endsWith('.pdf');
  }

  fileOver(event: any) {}
  fileLeave(event: any) {}

  // Save draft — uploads files to S3 then calls updateServicePurchaseOrder
  async saveDraft(isDraft?: boolean) {
    if (isDraft) {
      this.showConfirmationDialogue = false;
      this.showCloseDialogue = false;
    }

    this.fullLoaderService.showLoader();

    const Comment_attachmentFiles: { [key: string]: File } = {};
    let Comment_attachmentArray = [...this.uploadedAdditionalAttachmentsArray].filter(item => item.file);

    let attachmentsToSave: any[] = [];

    if (Comment_attachmentArray.length > 0) {
      const uploadPath = `purchaseOrder/${this.servicePurchaseOrderId}/header`;

      try {
        // Prepare S3 params for each attachment
        for (const attachment of Comment_attachmentArray) {
          const file = attachment.file;
          const fileName = file.name;
          const fileExt = fileName.split('.').pop();
          const systemName = `${uuidv4()}.${fileExt}`;
          const fileKey = `${uploadPath}/${systemName}`;

          attachment.systemName = systemName;
          attachment.s3Params = {
            fileKey,
            fileContentType: file.type,
          };

          Comment_attachmentFiles[fileName] = file;
        }

        // Get presigned URLs from backend
        const presignedAttachments = await this.SettingsService.getBulkAttachmentUrls(Comment_attachmentArray);

        // Upload each file to S3
        for (const attachment of presignedAttachments) {
          const file = Comment_attachmentFiles[attachment.name];
          const s3Path = this.awsSdkService.extractS3LocationFromUrl(attachment.s3_path);

          if (!file) {
            continue;
          }

          await this.webApiService.putRequestExternalApi(s3Path, file);

          attachment.s3_path = s3Path;
          attachment.fileKey = attachment.s3Params?.fileKey;
        }

        attachmentsToSave = presignedAttachments.map((att: { name: any; systemName: any; fileKey: any; s3_path: any; }) => ({
          name: att.name,
          systemName: att.systemName,
          fileKey: att.fileKey,
          s3_path: att.s3_path,
        }));

      } catch (error) {
        console.error('Attachment upload failed:', error);
        this.snack.open('Failed to upload attachments. Save aborted.', 'OK', { duration: 3000 });
        this.fullLoaderService.hideLoader();
        return;
      }
    }

    const params = {
      section: 'paymentTerms',
      purchaseOrderStatus: 14,
      purchaseOrderTabId: 3,
      quoteId: this.quoteId,
      serviceRfqId: this.serviceRfqId,
      userId: Number(this.cookieService.get('userId')),
      purchaseOrderId: this.servicePurchaseOrderId,
      termsConditionsAttachment: attachmentsToSave,
      billingAddressData: this.paymentFormGroup.get('billingAddress')?.value,
      billingAddressType: this.paymentFormGroup.get('billingAddress')?.value === this.billingAddress
        ? this.paymentFormGroup.get('billingAddressType')?.value
        : 2,
      portAgentId: this.paymentFormGroup.get('portAgentId')?.value,
    };

    await this.SettingsService.updateServicePurchaseOrder(params);

    if (isDraft) {
      this.router.navigate(['/operations/buyer-service-quote-list']);
    }

    this.fullLoaderService.hideLoader();
    this.snack.open('Payment Terms Data Saved', 'OK', { duration: 3000 });
  }

  // Tab navigation — save if possible, then navigate freely
  async selectMatTabLink(tabItem: any) {
    try { await this.saveDraft(); } catch (e) { console.error('Auto-save failed:', e); }
    this.fullLoaderService.showLoader();

    const qp = {
      serviceRfqId: this.serviceRfqId,
      quoteId: this.quoteId,
      servicePurchaseOrderId: this.servicePurchaseOrderId
    };

    if (tabItem.route == 'header') {
      this.router.navigate(["operations", "createServiceOrder", "header"], { queryParams: qp });
    } else if (tabItem.route == 'line-items') {
      this.router.navigate(["operations", "createServiceOrder", "line-items"], { queryParams: qp });
    } else if (tabItem.route == 'preview') {
      this.router.navigate(["operations", "createServiceOrder", "preview"], { queryParams: qp });
    }
  }

  // Close / Cancel
  async close(isDraft: boolean) {
    if (!isDraft) {
      this.showConfirmationDialogue = true;
    } else {
      this.showCloseDialogue = true;
    }
  }

  cancel() {
    this.showConfirmationDialogue = false;
    this.showCloseDialogue = false;
    this.router.navigate(['/operations/buyer-service-quote-list']);
  }

}
